<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/po/exchanges">{{$t('exchange_product')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{exchangeNum}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i
                    class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <router-link v-if="exchange.Status=='Draft'" :to="{ name: 'sale_exchange_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-pencil"></i> {{$t('edit')}}
            </router-link>
            <button v-if="exchange.Status=='Draft'" type="button" class="btn btn-outline-primary btn-sm no-bor"
                    @click="approveClick"><i class="fa fa-check"></i> {{ $t('approval') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i
                    class="fa fa-print"></i> {{ $t('print') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{exchange.CustomerName}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('stock')}}</td>
                                    <td>:</td>
                                    <td>{{exchange.RefNum}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('remark')}}</td>
                                    <td>:</td>
                                    <td>{{exchange.Remark}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('invoice_no') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td style="min-width: 150px;">{{exchange.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('ref_num')}}</td>
                                    <td>:</td>
                                    <td>{{exchange.RefNum}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(dateExchange, 'DD/MM/YYYY')}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor table-scroll">
                                <thead>
                                  <tr>
                                      <th class="th-width">{{$t('no')}}</th>
                                      <th class="th-width">{{$t('item_name')}}</th>
                                      <th class="th-width">{{$t('qty')}}</th>
                                      <th class="th-width">{{$t('uom')}}</th>
                                      <th class="text-right th-width">{{$t('cost')}}</th>
                                      <th class="text-right th-width">{{$t('price_sale')}}</th>
                                      <th class="text-right th-width">{{$t('discount')}}</th>
                                      <th class="text-right th-width">{{$t('total_cost')}}</th>
                                      <th class="text-right th-width">{{$t('total_sale')}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(ret, index) in lines" :key="index">
                                      <td>{{index + 1}}</td>
                                      <td>{{ret.ItemName}}</td>
                                      <td>{{ret.Quantity}}</td>
                                      <td>{{ret.UomName}}</td>
                                      <td class="text-right">{{$money(ret.Cost)}}</td>
                                      <td class="text-right">{{$money(ret.SalePrice)}}</td>
                                      <td class="text-right">{{$money(ret.Discount)}}</td>
                                      <td class="text-right">{{$money(ret.TotalCost)}}</td>
                                      <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th colspan="8" class="text-right">{{$t('grand_total')}}</th>
                                    <th class="text-right">
                                        {{$money(exchange.TotalAmount)}}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="8" class="text-right">{{$t('discount')}}</th>
                                    <th class="text-right">
                                        {{$money(exchange.Discount)}}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="8" class="text-right">{{$t('paid_amount')}}</th>
                                    <th class="text-right">
                                        {{$money(exchange.PaidAmount)}}
                                    </th>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                branch: {},
                exchange: {
                    IsApproved: false
                },
                dateExchange: '',
                stock: '',
                exchangeNum: '',
                customerName: '',
                customerId: '',
                Discount: 0,
                PaidAmount: 0,
                TotalAmount: 0,
                lines: []
            }
        },
        created() {
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('sale/exchange/find', {Id: id}).then(res => {
                    if (this.$isValid(res)) {
                        let data = res.data.Json;
                        this.exchange = data.Header;
                        this.dateExchange = data.Header.Date;
                        this.exchangeNum = data.Header.Num;
                        this.lines = data.Lines;
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            approveClick() {
                let loading = this.$loading.show();
                this.$api().post('sale/exchange/approved', {Id: this.$route.params.id}).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.push('/sale/exchanges');
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            printClick() {
                window.open('/print/exchange/' + this.$route.params.id, '_blank');
            }
        }
    }
</script>
<style scoped>
    .table-print thead tr th,
    .table-print tbody tr td {
        padding: 5px 0;
    }
</style>
